import React, { useContext, useEffect } from 'react';
import KiaLandingPage from './brands/KiaLandingPage';
import MazdaLandingPage from './brands/MazdaLandingPage';
import { SiteContext } from '../../../context/SiteContext';
import HyundaiLandingPage from './brands/HyundaiLandingPage';
import SuzukiLandingPage from './brands/SuzukiLandingPage';
import RenaultLandingPage from './brands/RenaultLandingPage';
import DaciaLandingPage from './brands/DaciaLandingPage';
import MitsubishiLandingPage from './brands/MitsubishiLandingPage';
import OriginalLandingPage from './brands/OriginalLandingPage';
import PolestarLandingPage from './brands/PolestarLandingPage';
import LotusLandingPage from './brands/LotusLandingPage';
import GenesisLandingPage from './brands/GenesisLandingPage';
import NissanLandingPage from './brands/NissanLandingPage';
import AlpineLandingPage from './brands/AlpineLandingPage';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getStartQuotePath } from './InsuranceMethods';
import useCarInsuranceController from '../../../hooks/insuranceJourney/useCarInsuranceController';
import { DealerHomepageOptions } from '../../common/CommonTypes';
import { useErrorBoundary } from 'react-error-boundary';

const InsuranceLandingPage = (): JSX.Element => {
  const { site } = useContext(SiteContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showBoundary } = useErrorBoundary();
  const { getDealerHomepageOptionsAsync } = useCarInsuranceController();

  const onBackendFailure = (err: string) => {
    showBoundary(new Error(err));
  };

  useEffect(() => {
    if (searchParams.get('currentstep') === 'cn-self-reg') {
      const dealerCode = searchParams.get('utm_source') ?? '';

      const dealerOptionsSuccess = (options: DealerHomepageOptions) => {
        navigate(
          getStartQuotePath(
            site.user.isDealer ?? false,
            site.brand.useAlternateEligibility
          ),
          { state: { dealer: dealerCode, dealerHomeOptions: options } }
        );
      };

      getDealerHomepageOptionsAsync(
        dealerCode,
        site.brand.tiaProductCode,
        site.user.token,
        dealerOptionsSuccess,
        onBackendFailure
      );
    }
  }, []);

  const getLandingPage = (): JSX.Element => {
    {
      switch (site.brand.brandName) {
        case 'kia': {
          return <KiaLandingPage />;
        }
        case 'mazda': {
          return <MazdaLandingPage />;
        }
        case 'hyundai': {
          return <HyundaiLandingPage />;
        }
        case 'suzuki': {
          return <SuzukiLandingPage />;
        }
        case 'renault': {
          return <RenaultLandingPage />;
        }
        case 'dacia': {
          return <DaciaLandingPage />;
        }
        case 'mitsubishi': {
          return <MitsubishiLandingPage />;
        }
        case 'original': {
          return <OriginalLandingPage />;
        }
        case 'polestar': {
          return <PolestarLandingPage />;
        }
        case 'lotus': {
          return <LotusLandingPage />;
        }
        case 'genesis': {
          return <GenesisLandingPage />;
        }
        case 'nissan': {
          return <NissanLandingPage />;
        }
        case 'alpine': {
          return <AlpineLandingPage />;
        }
        default: {
          return (
            <p>{`The ${site.brand.brandName} site is not configured for use`}</p>
          );
        }
      }
    }
  };

  //there needs to be a switch here to load the correct brand landing page
  return <div>{getLandingPage()}</div>;
};

export default InsuranceLandingPage;
